import React from 'react';
import { Container, Box } from '@mui/material';
import Header from './Header';
import Footer from './Footer';

const Layout = ({ children }) => {
  return (
    <Container 
      maxWidth="xl" 
      sx={{
        padding: 4,
        backgroundColor: 'rgba(211, 211, 211, 0.3)', // Light gray transparent background
        minHeight: '100vh'
      }}
    >
      {/* Header: Always visible */}
      <Header />

      {/* Main Content */}
      <Box sx={{ paddingTop: { xs: '88px', md: '96px' } }}>
        {children}
      </Box>

      {/* Footer: Always visible */}
      <Footer />
    </Container>
  );
};

export default Layout;